import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'adtob'
})
export class AdtobPipe implements PipeTransform {

  transform(value: any): any {
    if (!value) {
      return '';
    }
    const date1 = new Date(value);
    let options:any = {
      year: "numeric",month: "short",day: "2-digit"      
    };
    return date1.toLocaleString('th-TH', options);
    /*
    const monthNames = ['มค.','กพ.','มีค.','เมย.','พค.','มิย.','กค.','สค.','กย.','ตค.','พย.','ธค.'];
    const currentdate = new Date(value);
    return `${currentdate.getDate()} ${monthNames[currentdate.getMonth()]} ${currentdate.getFullYear()+543}`;
    */
  }

}
